import ZoomInIcon from '@mui/icons-material/ZoomIn';
import ZoomOutIcon from '@mui/icons-material/ZoomOut';
import { Box, Typography } from '@mui/material';
import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { useStudio } from '../../context';
import { StudioActionBarBox, StudioActionIconButton } from '../lib';

const ZOOM_STEP = 0.1;
const MIN_ZOOM = 0.25;
const MAX_ZOOM = 3;

export const StudioZoomControls = () => {
  const { t } = useTranslation();
  const { setZoom, zoom } = useStudio();

  const zoomIn = useCallback(() => {
    setZoom(Math.min(zoom + ZOOM_STEP, MAX_ZOOM));
  }, [zoom, setZoom]);

  const zoomOut = useCallback(() => {
    setZoom(Math.max(zoom - ZOOM_STEP, MIN_ZOOM));
  }, [zoom, setZoom]);

  const resetZoom = useCallback(() => {
    setZoom(1);
  }, [setZoom]);

  const zoomPercent = Math.round(zoom * 100);

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        py: 1,
      }}
    >
      <StudioActionBarBox>
        <StudioActionIconButton
          label={t('pages.studio.edit.zoom.zoom_out')}
          onClick={zoomOut}
          disabled={zoom <= MIN_ZOOM}
          size="small"
        >
          <ZoomOutIcon />
        </StudioActionIconButton>
        <Typography
          onClick={resetZoom}
          sx={{
            minWidth: 45,
            textAlign: 'center',
            cursor: 'pointer',
            userSelect: 'none',
            fontSize: 13,
            color: 'studio.rulerText',
            '&:hover': {
              opacity: 0.7,
            },
          }}
        >
          {zoomPercent}%
        </Typography>
        <StudioActionIconButton
          label={t('pages.studio.edit.zoom.zoom_in')}
          onClick={zoomIn}
          disabled={zoom >= MAX_ZOOM}
          size="small"
        >
          <ZoomInIcon />
        </StudioActionIconButton>
      </StudioActionBarBox>
    </Box>
  );
};
